import React, { SVGProps } from 'react'
const SvgOrganizationFilled = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill={props.fill || '#172C52'}
        d="m4.066 3.177 10.167 1.682a.917.917 0 0 1 .767.905V21H3.917A.917.917 0 0 1 3 20.083V4.081a.917.917 0 0 1 1.066-.904Z"
      />
      <path
        fill={props.fill || '#172C52'}
        fillRule="nonzero"
        d="M3.917 2.414c-.92 0-1.667.746-1.667 1.667v16.002c0 .92.746 1.667 1.667 1.667H15a.75.75 0 0 0 .75-.75V5.764c0-.816-.59-1.512-1.395-1.645L4.19 2.437l-.136-.017-.136-.006ZM14.11 5.6l.045.015a.167.167 0 0 1 .094.15V20.25H3.917a.167.167 0 0 1-.167-.167V4.081c0-.092.075-.167.167-.167l.027.002L14.11 5.6Z"
      />
      <path
        fill={props.fill || '#172C52'}
        d="m15 10.647 5.255 1c.432.083.745.46.745.901v7.535c0 .507-.41.917-.917.917H15V10.647Z"
      />
      <path
        fill={props.fill || '#172C52'}
        fillRule="nonzero"
        d="M15.14 9.91a.75.75 0 0 0-.89.737V21c0 .414.336.75.75.75h5.083c.92 0 1.667-.746 1.667-1.667v-7.535c0-.8-.569-1.488-1.355-1.637l-5.255-1Zm.61 10.34v-8.697l4.365.831a.167.167 0 0 1 .135.164v7.535l-.008.053a.167.167 0 0 1-.159.114H15.75Z"
      />
      <path
        fill="#ECEDEF"
        d="M7.517 15.687h2.966c.507 0 .917.41.917.917V21H6.6v-4.396c0-.507.41-.917.917-.917Z"
      />
      <path
        fill={props.fill || '#172C52'}
        fillRule="nonzero"
        d="M10.483 14.937H7.517c-.92 0-1.667.746-1.667 1.667V21c0 .414.336.75.75.75h4.8a.75.75 0 0 0 .75-.75v-4.396c0-.92-.746-1.667-1.667-1.667Zm0 1.5.053.009a.167.167 0 0 1 .114.158v3.645h-3.3v-3.645c0-.092.075-.167.167-.167h2.966Z"
      />
      <g fill="#ECEDEF" fillRule="nonzero">
        <path d="M8 12.603a.75.75 0 0 1 .102 1.493L8 14.103H5a.75.75 0 0 1-.102-1.493L5 12.603h3ZM8 9.78a.75.75 0 0 1 .102 1.493L8 11.279H5a.75.75 0 0 1-.102-1.493L5 9.78h3ZM8 6.956a.75.75 0 0 1 .102 1.493L8 8.456H5a.75.75 0 0 1-.102-1.493L5 6.956h3ZM13 12.603a.75.75 0 0 1 .102 1.493l-.102.007h-3a.75.75 0 0 1-.102-1.493l.102-.007h3ZM13 9.78a.75.75 0 0 1 .102 1.493l-.102.006h-3a.75.75 0 0 1-.102-1.493L10 9.78h3ZM13 6.956a.75.75 0 0 1 .102 1.493L13 8.456h-3a.75.75 0 0 1-.102-1.493L10 6.956h3Z" />
      </g>
      <path
        fill="#ECEDEF"
        fillRule="nonzero"
        d="M19.8 17.309a.75.75 0 0 1 .102 1.493l-.102.007h-3a.75.75 0 0 1-.102-1.493l.102-.007h3ZM19.8 14.35a.75.75 0 0 1 .102 1.494l-.102.007h-3a.75.75 0 0 1-.102-1.493l.102-.007h3Z"
      />
    </g>
  </svg>
)
export default SvgOrganizationFilled
